import { Chip } from '@material-ui/core';
import { Product } from '@setvi/shared/interfaces';

interface StockInfoProps {
  stockInfo: Product['stockInfo'];
}

export const getStockInfo = ({
  allWarehouses = false,
  warehouses
}: Product['stockInfo']) => {
  if (allWarehouses) return 'Stocked';

  const warehousesWithStock = warehouses.filter(warehouse => warehouse.stock);

  if (warehousesWithStock?.length > 0)
    return `Stocked - ${warehousesWithStock?.[0]?.warehouseName}`;

  return 'Not Stocked';
};

export const StockInfo = ({ stockInfo }: StockInfoProps) => {
  if (!stockInfo) return null;

  return (
    <Chip variant="outlined" size="small" label={getStockInfo(stockInfo)} />
  );
};
